<template>
    <form autocomplete="off">
        <div class="row gy-3">
            <div class="col-12">
                <label>Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.name"
                   placeholder="Enter full name" :class="{ 'is-invalid': v$.form.name.$error }">
                <div class="invalid-feedback" v-for="(item, index) in v$.form.name.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>
            <div class="col-lg-7">
                <label>Institution <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.institution"
                    placeholder="Enter institution or company name" :class="{ 'is-invalid': v$.form.institution.$error }">
                <div class="invalid-feedback" v-for="(item, index) in v$.form.institution.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>
            <div class="col-lg-5">
                <label>Position <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.position"
                    placeholder="Enter referee position" :class="{ 'is-invalid': v$.form.position.$error }">
                <div class="invalid-feedback" v-for="(item, index) in v$.form.position.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>
            <div class="col-lg-6">
                <label>Email <span class="text-danger">*</span></label>
                <input type="email" class="form-control" v-model="form.email"
                    placeholder="Enter email" :class="{ 'is-invalid': v$.form.email.$error }">
                <div class="invalid-feedback" v-for="(item, index) in v$.form.email.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>
            <div class="col-lg-6">
                <label>Telephone <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.mobile"
                   placeholder="Enter phone number" :class="{ 'is-invalid': v$.form.mobile.$error }">
                <div class="invalid-feedback" v-for="(item, index) in v$.form.mobile.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>
            <div class="col-12">
                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="primary" type="button" @click.prevent="editMode ? update() : create()">
                        {{ editMode ? 'Update' : 'Submit' }}
                    </b-button>
                </div>
            </div>

        </div>
    </form>
</template>

<script>
import { required, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props: {
        editItem: {
            type: Object,
            default: null
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                name: "",
                institution: "",
                position: "",
                email: "",
                mobile: ""
            }
        }
    },
    validations() {
        return {
            form: {
                name: {
                    required: helpers.withMessage("Name is required", required)
                },
                institution: {
                    required: helpers.withMessage("Institution is required", required)
                },
                position: {
                    required: helpers.withMessage("Position is required", required)
                },
                email: {
                    required: helpers.withMessage("Email is required", required),
                    email: helpers.withMessage("Please enter a valid email address", email)
                },
                mobile: {
                    required: helpers.withMessage("Telephone is required", required),
                    pattern: helpers.withMessage("Telephone must start with 0 and be exactly 11 digits",
                        value => {
                            const pattern = /^0\d{10}$/;
                            return !value || pattern.test(value.replace(/\s+/g, ""));
                        }
                    )
                },
            }
        }
    },
    methods: {
        create() {
            this.v$.$validate().then(result => {
                if (!result) {
                    this.alertError(this.v$.$errors[0].$message);
                    return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post('/referees/create', this.form)
                    .then(response => {
                        this.$store.dispatch("changeLoaderValue", false);
                        if (response.data.success) {
                            this.$emit("addedItem", response.data.data);
                            this.resetForm();
                        }
                    });
            });
        },
        update() {
            this.v$.$validate().then(result => {
                if (!result) {
                    this.alertError(this.v$.$errors[0].$message);
                    return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post(`/referees/${this.editItem.id}/update`, this.form)
                    .then(response => {
                        this.$store.dispatch("changeLoaderValue", false);
                        if (response.data.success) {
                            this.$emit("updatedItem", response.data.data);
                            this.resetForm();
                        }
                    });
            });
        },
        resetForm() {
            this.v$.$reset();
            this.$emit("closeMe");
        }
    },
    created() {
        if (this.editMode) {
            this.form = this.$filters.patchUpdatables(this.form, this.editItem);
        }
    }
}
</script>